<div class="header-bar">
  <h1>AutoDirect</h1>
</div>
<p-tabView class="tab-padding no-widget-border">
  <p-tabPanel id="autoDirectSummary" header="History" #tabUKPostcodes>
    <auto-direct-summary></auto-direct-summary>
  </p-tabPanel>
  <p-tabPanel id="autoDirectSettings" header="Settings" #tabLondonPostcodes>
    <auto-direct-settings></auto-direct-settings>
  </p-tabPanel>
</p-tabView>
